<template>
  <b-card no-body>
    <b-card-header v-if="withHeader">
      <slot name="header"/>
    </b-card-header>
    <b-card-body>
      <div class="d-flex flex-wrap">
        <div>
          <h4 v-if="title" class="card-title">{{ title }}</h4>
          <h6 v-if="subTitle" class="card-subtitle">{{ subTitle }}</h6>
        </div>
        <div class="ml-auto d-inline-flex flex-wrap">
          <slot name="header-right"/>
        </div>
      </div>
      <slot/>
    </b-card-body>
    <template v-if="secondBody">
      <div>
        <hr>
      </div>
      <b-card-body>
        <slot name="second-body"/>
      </b-card-body>
    </template>
    <b-card-footer v-if="withFooter">
      <slot name="footer"/>
    </b-card-footer>
  </b-card>
</template>

<script>
export default {
  name: "AdminPanel",
  props: {
    title: String,
    subTitle: String,
    secondBody: Boolean,
    withHeader: Boolean,
    withFooter: Boolean,
  }
}
</script>